import { render, staticRenderFns } from "./FileBoxCapacity.vue?vue&type=template&id=5b05132d&"
import script from "./FileBoxCapacity?vue&type=script&lang=ts&"
export * from "./FileBoxCapacity?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports